import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.1_@parcel+watcher@2.5.1_@types+node@24.9.1_eslint-ts-patch@8.56.0-0_magicast@_e1f5fa368ce54843bf5b5a5ae2ba2e14/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}